/* Variant selection + price live-update (Dawn 15.4.1+)
   External asset, loaded in <head> with defer so it always executes
   even when the body is re-rendered client-side.
   Uses document-level event delegation (survives DOM swaps).
   Coexists with YMQ Options.

   2026-05-30 PATCH (freeze fix):
   REMOVED the body-wide MutationObserver. It was firing updateUI()
   on every child-list mutation anywhere in <body>, which Camweara,
   Klaviyo and Reputon trigger constantly. Each updateUI() call ran
   classList.toggle on .price elements, invalidating layout, which
   triggered more app-driven mutations -> feedback loop -> mobile freeze.

   The `change` event delegation below is sufficient for user-initiated
   variant changes. A single setTimeout-deferred updateUI() call after
   load handles the first-paint case (variant from URL, pre-selected).
*/
(function () {
  var L = function () {};

  var productData = null;
  var lastHandle = null;

  function fmt(c) {
    return '$' + (c / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' AUD';
  }

  function loadProductData() {
    if (!window.location.pathname.includes('/products/')) { return; }
    var handle = window.location.pathname;
    if (handle === lastHandle && productData) { updateUI('cached'); return; }
    lastHandle = handle;
    fetch(handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        productData = d;
        L('product loaded:', d.title, '|', d.variants.length, 'variants');
        updateUI('fetch');
      })
      .catch(function (e) { L('fetch failed', e); });
  }

  function getSelectedOptions() {
    var c = document.querySelector('variant-selects, variant-radios');
    if (!c) { return []; }
    var vals = [];
    c.querySelectorAll('fieldset').forEach(function (fs) {
      var ck = fs.querySelector('input[type="radio"]:checked');
      if (ck) { vals.push(ck.value); }
    });
    c.querySelectorAll('select').forEach(function (s) { vals.push(s.value); });
    if (vals.length === 0) {
      c.querySelectorAll('input[type="radio"]:checked').forEach(function (i) { vals.push(i.value); });
    }
    return vals;
  }

  function findVariant(opts) {
    if (!productData || !productData.variants) { return null; }
    return productData.variants.find(function (v) {
      return (!v.option1 || v.option1 === opts[0]) &&
             (!v.option2 || v.option2 === opts[1]) &&
             (!v.option3 || v.option3 === opts[2]);
    });
  }

  function gjScope() {
    return document.querySelector('.product__info-container') || document.createElement('div');
  }

  function updateFormId(id) {
    gjScope().querySelectorAll('input.product-variant-id, product-form form input[name="id"], form[action*="/cart/add"] input[name="id"]')
      .forEach(function (i) { i.value = id; i.removeAttribute('disabled'); });
  }

  function updateURL(id) {
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.get('variant') != id) {
        u.searchParams.set('variant', id);
        window.history.replaceState({}, '', u.toString());
      }
    } catch (e) {}
  }

  function updatePrice(v) {
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    var scope = gjScope();
    scope.querySelectorAll('.price').forEach(function (el) {
      el.classList.toggle('price--on-sale', onSale);
      el.classList.toggle('price--show-badge', onSale);
    });
    scope.querySelectorAll('.price-item--sale.price-item--last, .price__regular .price-item--regular')
      .forEach(function (el) { el.textContent = fmt(v.price); });
    scope.querySelectorAll('.price__sale s.price-item--regular, .price__sale .price-item--regular')
      .forEach(function (el) { if (onSale) { el.textContent = fmt(v.compare_at_price); } });
    scope.querySelectorAll('.price__badge-sale').forEach(function (el) {
      el.style.display = onSale ? '' : 'none';
    });
  }

  function updateUI(src) {
    if (!productData) { return; }
    var opts = getSelectedOptions();
    if (opts.length === 0) { L('updateUI(' + src + '): no options found yet'); return; }
    var v = findVariant(opts);
    if (!v) { L('no variant match for', JSON.stringify(opts)); return; }
    updateFormId(v.id);
    updateURL(v.id);
    updatePrice(v);
    L('updated -> variant', v.id, fmt(v.price), '(' + src + ')');
  }

  /* Delegated change handler — fires on every variant change.
     This is the primary path; runs once per user interaction, not per DOM mutation. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    if (t.closest('variant-selects') || t.closest('variant-radios') ||
        t.matches('select[name^="options"], input[name^="options"]')) {
      L('change on', t.tagName, t.value);
      setTimeout(function () { updateUI('change'); }, 50);
    }
  });

  /* Initial load: fetch product JSON, then run updateUI once. */
  loadProductData();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      loadProductData();
      /* One-shot first-paint sync, after Dawn finishes wiring the variant picker. */
      setTimeout(function () { updateUI('first-paint'); }, 500);
    });
  } else {
    setTimeout(function () { updateUI('first-paint'); }, 500);
  }

  /* REMOVED 2026-05-30: body-wide MutationObserver.
     Caused freeze loop with Camweara/Klaviyo/Reputon DOM churn.
     The change handler above is sufficient for variant switching.
     If a future feature needs to react to section re-renders,
     listen to Dawn's `sections:section-rendered` event on document
     instead of observing the whole body subtree. */
})();
